import React, { useState } from "react";
import { FullScreenBelowXXL } from "../../../../../Constant";
import CommonFullScreenData from "../Common/CommonFullScreenData";

const FullScreenBelowXxl = () => {
  const [fullScreenXxl, setFullScreenXxl] = useState(false);
  const fullScreenXxlToggle = () => setFullScreenXxl(!fullScreenXxl);
  return <CommonFullScreenData color="danger-2x" onClick={fullScreenXxlToggle} title={FullScreenBelowXXL} fullscreen="xxl" isOpen={fullScreenXxl} toggle={fullScreenXxlToggle} />;
};

export default FullScreenBelowXxl;
